import type { KpiColorGroup } from "../kpiSections";

export interface KpiColors {
  readonly main: string;
  readonly background: string;
  readonly border: string;
}

function kpiColors(main: string, rgb: string): KpiColors {
  return { main, background: `rgba(${rgb}, 0.09)`, border: `rgba(${rgb}, 0.22)` };
}

export const KPI_PALETTE: Record<KpiColorGroup, KpiColors> = {
  orders: kpiColors("#3557a1", "53, 87, 161"),
  deposited: kpiColors("#2e7d32", "46, 125, 50"),
  cancelled: kpiColors("#c62828", "198, 40, 40"),
  margin: kpiColors("#6a1b9a", "106, 27, 154"),
  calculations: kpiColors("#00838f", "0, 131, 143"),
  ordered: kpiColors("#3949ab", "57, 73, 171"),
  activity: kpiColors("#3557a1", "53, 87, 161"),
  meetings: kpiColors("#ef6c00", "239, 108, 0"),
};
